module.exports = __webpack_public_path__ + "img/1.1aa81442.png";